/* eslint-disable max-len */
import { t } from '@lingui/macro';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import {
    LeftButtons, useSelectorIsOneRosterActivatedSchool, AppState, useSelectorIsInitialized
} from '../../../../app';
import questionMarkIcon from '../../../../components/icons/question-mark.svg';
import {
    useSelectorRolloverModuleId,
    useSelectorMxAPACCountryCodes
} from '../../../../configuration';
import {
    useSelectorHasCurrentProductAccess,
    useSelectorIsTeacherUser, useSelectorLeftNavButtons
} from '../../../../user-profiles';
import { ROUTES } from '../../../index';
import { ThreeEssentialsBadgeCustom } from '../three-essentials-badge-custom/three-essentials-badge-custom';
import { ThreeEssentialsBadge } from '../three-essentials-badge/three-essentials-badge';
import { Container } from './three-essentials-welcome-page.styled';
import { ModuleTypes } from '@api';
import { SVGAsset } from '@components';

export const ThreeEssentialsWelcomePage = () => {
    const isOneRosterActivatedSchool = useSelectorIsOneRosterActivatedSchool();
    const countryCode = useSelector<AppState, string>(state => state.userProfiles.data?.country?.code || 'AUS');
    const mxAPACCountryCodes = useSelectorMxAPACCountryCodes();
    const rolloverModuleId = useSelectorRolloverModuleId();
    const buttons = useSelectorLeftNavButtons();
    const history = useHistory();
    const isTeacher = useSelectorIsTeacherUser();
    const hasAccess = useSelectorHasCurrentProductAccess();
    const isInitialized = useSelectorIsInitialized();
    const clickHandler = ({
        moduleLink = '',
        moduleType,
        groupId,
        moduleId,
        isAvailableForOneRosterSchoolOnly
    }: LeftButtons) => {
        const disableRollover = !isOneRosterActivatedSchool && moduleId && moduleId === parseInt(rolloverModuleId) && mxAPACCountryCodes.includes(countryCode);

        if (disableRollover) {
            history.push(`${ROUTES.content}/${moduleId}`);
        } else {
            if (isAvailableForOneRosterSchoolOnly) {
                window.open(moduleLink);
            } else {
                if (moduleType === ModuleTypes.content) {
                    history.push(`${ROUTES.content}/${moduleId}`);
                } else if (moduleType === ModuleTypes.landing) {
                    history.push(`${ROUTES.landing}/${groupId}`);
                } else if (moduleType === ModuleTypes.welcome) {
                    history.push(ROUTES.welcome);
                }
            }
        }
    };

    if (!isInitialized) return null;

    return (
        <Container data-testid={'three-essential-welcome-page-test-id'}>
            {
                buttons.map(button => {
                    if (!button.moduleId) {
                        return null;
                    }

                    return (
                        <ThreeEssentialsBadge
                            key={`button-${button.text}`}
                            title={button.text}
                            icon={button.icon}
                            description={button.tooltip}
                            showButton={button.isAvailableForOneRosterSchoolOnly}
                            clickHandler={() => clickHandler({ ...button })}

                        />
                    );
                })
            }
            {isTeacher && hasAccess && (
                <ThreeEssentialsBadgeCustom
                    title={t`welcome.boardingAndSupport.Title`}
                    description={t`welcome.boardingAndSupport.Description`}
                    icon={<SVGAsset src={questionMarkIcon} width={60} fill={'secondary.400 !important'} stroke={'secondary.400 !important'} />}
                    id={'boardingAndSupportTile'}
                />
            )}
        </Container>
    );
};
